<template>
  <header class="app-header">
    <div class="logo">
      <img src="@/assets/images/logo/login_logo.png" alt="NOSP Inventory" height="25">
    </div>
    
    <nav class="main-nav">
      <router-link to="/inventory" class="nav-link">NOSP 인벤토리</router-link>
      <router-link to="/users" class="nav-link" v-if="isAdminUser">사용자 관리</router-link>
    </nav>
    
    <div class="spacer"></div>
    <div v-if="isUserLoggedIn" class="user-info">
      <span class="welcome-text">{{ welcomeMessage }}</span>
      <div class="dropdown">
        <button class="dropdown-toggle">
          <i class="user-icon">👤</i>
          <span>{{ userName }}</span>
        </button>
        <div class="dropdown-menu">
          <button class="dropdown-item" @click="handleLogout">로그아웃</button>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, computed, onMounted, defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { getCurrentUser, isLoggedIn, isAdmin } from '@/utils/user-auth';
import { logout } from '@/api/user';

// 컴포넌트 이름 정의
defineComponent({
  name: 'AppHeader'
});

const router = useRouter();
const isUserLoggedIn = ref(false);
const userName = ref('');
const userGrade = ref('');
const isAdminUser = ref(false);

const welcomeMessage = computed(() => {
  if (!isUserLoggedIn.value) return '';
  return `안녕하세요, ${userName.value}님!`;
});

const handleLogout = () => {
  logout(router);
};

const updateUserInfo = () => {
  isUserLoggedIn.value = isLoggedIn();
  
  if (isUserLoggedIn.value) {
    const user = getCurrentUser();
    if (user) {
      userName.value = user.name || '';
      userGrade.value = user.grade || '';
      isAdminUser.value = isAdmin();
    }
  }
};

onMounted(() => {
  updateUserInfo();
});
</script>

<style scoped>
.app-header {
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.logo {
  display: flex;
  align-items: center;
}

.spacer {
  flex-grow: 1;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.welcome-text {
  margin-right: 10px;
  font-size: 14px;
  color: #666;
}

.dropdown {
  position: relative;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.dropdown-toggle:hover {
  background-color: #f5f5f5;
  border-radius: 4px;
}

.user-icon {
  font-size: 16px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  display: none;
  min-width: 120px;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 1000;
}

.dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 8px 12px;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.main-nav {
  display: flex;
  margin-left: 30px;
}

.nav-link {
  padding: 0 16px;
  height: 50px;
  display: flex;
  align-items: center;
  color: #444;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s, background-color 0.3s;
  position: relative;
}

.nav-link:hover {
  color: #1a73e8;
  background-color: rgba(26, 115, 232, 0.05);
}

.nav-link.router-link-active {
  color: #1a73e8;
  font-weight: 600;
}

.nav-link.router-link-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #1a73e8;
}
</style> 